export default "__VITE_ASSET__BXfyR2uw__"